module.exports = __webpack_public_path__ + "img/icon_tap_05.44a2a683.svg";